<template>
  <div class="view-container">
    <div class="vs-con-loading__container flex flex-col justify-around items-center" ref=userDetails>
      <div class="max-w-md w-full sm:w-1/2 lg:w-1/3 xl:w-1/3 flex flex-wrap content-center justify-center">

        <ValidationObserver class="w-full" ref="validator" v-slot="{ invalid }">
          <form @submit.prevent="submit()">

            <base-input :label-placeholder="$t('users.table.name')" :name="$t('users.table.name')"
                        autofocus class="w-full"
                        rules="required|alpha"
                        v-model="user.name"/>

            <base-input :label-placeholder="$t('users.table.surname')" :name="$t('users.table.surname')"
                        class="w-full" rules="required|alpha"
                        v-model="user.surname"/>

            <base-input :label-placeholder="$t('users.table.email')" :name="$t('users.table.email')" class="w-full"
                        rules="required|email" type="email"
                        v-model="user.email"/>

            <date-picker :input-label="$t('users.table.birthday')" :name="$t('users.table.birthday')"
                         class="w-ful" rules="required"
                         :config="birthdayConfig"
                         v-model="user.birthday">
            </date-picker>

            <base-input :label-placeholder="$t('users.table.phone')" :name="$t('users.table.phone')"
                        class="w-full" rules="required"
                        v-model="user.phone"/>

            <base-multiselect
              :custom-label="customRoleLabel"
              :input-label="$t('users.table.role')"
              :multiple="true"
              :name="$t('users.table.role')"
              :options="roles"
              :value="user.roles"
              @input="rolesChange"
              label="name"
              rules="required"
              track-by="id"
              v-if="roles.length"/>

            <base-input :label-placeholder="$t('users.table.external_reference')" :name="$t('users.table.external_reference')"
                        class="w-full"
                        v-model="user.external_reference"/>

            <date-picker :input-label="$t('users.table.started_working')" :name="$t('users.table.started_working')"
                         class="w-ful" rules="required" v-if="action === 'create'"
                         v-model="user.started_working"/>

            <base-button :disabled="invalid" :loading="loading" button="filled" class="w-full my-5" color="success"
                         type="submit">
              {{ $t(`buttons.${[action]}`) }}
            </base-button>
          </form>
        </ValidationObserver>
      </div>
    </div>
  </div>
</template>

<script>
  import DatePicker from "../DatePicker";
  import moment from "moment";

  export default {
    name: "UserDetailsComponent",
    components: {
      DatePicker
    },
    props: {
      user: {
        type: Object,
        required: true
      },
      roles: {
        type: Array,
        required: false
      },
      action: {
        type: String,
        required: true
      },
      isMyProfile: {
        type: Boolean,
        required: false
      },
      loading: {
        type: Boolean,
        default: false
      }
    },
    data: () => ({
      birthdayConfig: {
        maxDate: moment().toDate(),
        dateFormat: "d M Y",
      },
    }),
    methods: {
      async submit () {
        const isValid = await this.$refs.validator.validate();
        if (!isValid) return;
        this.$emit('confirm')
      },
      rolesChange (val) {
        this.user.roles = val
      },
      customRoleLabel ({name}) {
        return this.$t(`roles.${name}`)
      }
    },
  }
</script>

<style lang="scss">
</style>
